module.exports = __webpack_public_path__ + "static/img/4.d69388e2.png";